import React from 'react'

function CorporigidoLogo(){
    return (
        <strong>CORPORIGIDO.<span className="Red">X</span><span className='Green'>Y</span><span className="Blue">Z</span></strong>
    )
}

export default CorporigidoLogo